/**
 * ContactFormController
 * CF7 の残存表示 (前回送信後の「Thank you for your message. It has been sent.」等) を
 * SPA 遷移や bfcache 復元のたびにクリアする。
 *
 * 背景:
 *   Barba SPA 遷移 / ブラウザ back-forward cache では submit 直後の DOM が
 *   そのまま復元される。CF7 の .wpcf7-response-output に成功メッセージが
 *   残ったままだと「まだ何も送信していないのに送信完了が出ている」ように見える。
 *
 * 対策:
 *   init のたびに response-output のテキストを空にし、form から状態クラスを外す。
 *   CF7 デフォルトCSS は form.init 状態で response-output を display:none にするため、
 *   .init クラスを付け直して初期状態に戻す。
 */
export const ContactFormController = {
  clear() {
    document.querySelectorAll( '.wpcf7-response-output' ).forEach( ( el ) => {
      el.textContent = '';
      el.setAttribute( 'aria-hidden', 'true' );
    } );
    document.querySelectorAll( '.wpcf7 form' ).forEach( ( form ) => {
      form.classList.remove( 'sent', 'failed', 'invalid', 'unaccepted', 'spam', 'aborted', 'submitting' );
      form.classList.add( 'init' );
    } );
  },

  init() {
    this.clear();
    // bfcache 復元時 (ブラウザバック等) にもクリアする。init が繰り返し呼ばれても
    // 二重登録しないように 1度きりのフラグで制御。
    if ( ! this._bfcacheBound ) {
      window.addEventListener( 'pageshow', ( e ) => {
        if ( e.persisted ) this.clear();
      } );
      this._bfcacheBound = true;
    }
  },
};
